import React, { useEffect, useRef, useState, useMemo } from "react";
import {
    StyledContainer,
    GridContainer,
    StyledImageWrapper,
    StyledImage,
    StyledOverlay,
} from "./StyledComponents";
import convertS3ImageUrl from "../../../assets/store/convertS3ImageUrl";

const StackedGallery = ({
    image_gallery,
    divId,
    rowId,
    rowData,
    defaultFontFamily,
    containerRef,
    imagesUnconverted,
}) => {
    const { isMobile } = window?.window?.deviceDetect?.getWindowData() || {};

    const {
        background_color,
        caption_overlay_color,
        caption_text_color,
        gallery_type,
        header_text,
        header_text_color,
    } = image_gallery;

    const dataAttributes = {
        "data-divid": divId,
        "data-rowid": rowId,
        "data-gallerytype": gallery_type,
        "data-header": header_text,
        "data-galleryid": image_gallery.id,
    };

    const images = useMemo(() => {
        const convertedImages = imagesUnconverted.map((image) => {
            image.url = convertS3ImageUrl(image.url, {
                resize: { width: isMobile ? 300 : 600 },
            });

            return image;
        });

        return convertedImages;
    }, [imagesUnconverted]);

    const handleLinkClick = (image) => {
        if (!image.link) return;
        window.open(
            image.link,
            image.open_link_in_new_tab ? "_blank" : "_self"
        );
    };

    return (
        <StyledContainer ref={containerRef}>
            <GridContainer
                className="FODImageGallery"
                bgColor={rowData.background_color}
            >
                {images.map((image, index) => {
                    if (!image.url) return;
                    const specificAttributes = {
                        "data-imagenumber": index + 1,
                        "data-caption": image.text,
                        "data-imageurl": image.url,
                    };

                    const gaAttributes = {
                        "data-clickindex": index + 1,
                        "data-imagegalleryid": rowData.image_gallery.id,
                        "data-imageurl": image.url,
                        "data-clickurl": image.url,
                        "data-imageindex": index,
                    };

                    return (
                        <StyledImageWrapper
                            className="FODGAImageGalleryItem"
                            key={`image-gallery-image-${index}`}
                            hasLink={
                                image.link &&
                                !!(typeof image.link === "object"
                                    ? image.link.link
                                    : image.link)
                            }
                        >
                            <StyledOverlay
                                className="ImageOverlay"
                                hasLink={
                                    image.link &&
                                    !!(typeof image.link === "object"
                                        ? image.link.link
                                        : image.link)
                                }
                            />
                            <StyledImage
                                {...gaAttributes}
                                {...specificAttributes}
                                {...dataAttributes}
                                className="FODGAImageGalleryLink FODV5GAImageGalleryClickEvent"
                                draggable={false}
                                src={image.url}
                                onClick={() =>
                                    handleLinkClick(
                                        typeof image.link === "object"
                                            ? image.link
                                            : image
                                    )
                                }
                            />
                        </StyledImageWrapper>
                    );
                })}
            </GridContainer>
        </StyledContainer>
    );
};

export default StackedGallery;
